import { CommonContainerInterface } from 'common/types/entities/EntityInterface'
import { containerCss } from 'common/utils/styleUtilsNew'
import styled from 'styled-components'

const OrderBumpWrapperUi = styled.div<CommonContainerInterface>`
  overflow: hidden;
  ${containerCss}
`

export default OrderBumpWrapperUi
